"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const brand = "#BA0C2F";
const headerTextColor = brand;
const headerBackgroundColor = "#ffffff";
const mainInfoLandscape = brand;
const mainInfoPortrait = brand;
const style = "normal";
const colorAppBar = "#ffffff";
const colorOnAppBar = "#BA0C2F"; // red
const colorPrimary = "#BA0C2F";
const colorPrimaryDarker = "#8b0923";
const colorPrimaryLighter = "#fbc4cf";
const colorOnPrimary = "#ffffff";
const colorSecondary = "#BA0C2F";
const colorOnSecondary = "ffffff";
const colorTiles = ["#BA0C2F", "#BA0C2F", "#BA0C2F"];
const fontFamily = `
@font-face {
    font-family: 'NotoSans';
    src: url('/fonts/notosans/NotoSans-Regular-webfont.eot');
    src: url('/fonts/notosans/NotoSans-Regular-webfont.eot?#iefix') format('embedded-opentype'),
         url('/fonts/notosans/NotoSans-Regular-webfont.woff') format('woff'),
         url('/fonts/notosans/NotoSans-Regular-webfont.ttf') format('truetype'),
         url('/fonts/notosans/NotoSans-Regular-webfont.svg#noto_sansregular') format('svg');
    font-weight: 400;
    font-style: normal;

}

@font-face {
    font-family: 'NotoSans';
    src: url('/fonts/notosans/NotoSans-Bold-webfont.eot');
    src: url('/fonts/notosans/NotoSans-Bold-webfont.eot?#iefix') format('embedded-opentype'),
         url('/fonts/notosans/NotoSans-Bold-webfont.woff') format('woff'),
         url('/fonts/notosans/NotoSans-Bold-webfont.ttf') format('truetype'),
         url('/fonts/notosans/NotoSans-Bold-webfont.svg#noto_sansregular') format('svg');
    font-weight: 700;
    font-style: normal;

}

@font-face {
    font-family: 'NotoSans';
    src: url('/fonts/notosans/NotoSans-Italic-webfont.eot');
    src: url('/fonts/notosans/NotoSans-Italic-webfont.eot?#iefix') format('embedded-opentype'),
         url('/fonts/notosans/NotoSans-Italic-webfont.woff') format('woff'),
         url('/fonts/notosans/NotoSans-Italic-webfont.ttf') format('truetype'),
         url('/fonts/notosans/NotoSans-Italic-webfont.svg#noto_sansregular') format('svg');
    font-weight: 400;
    font-style: italic;
}

@font-face {
    font-family: 'NotoSans';
    src: url('/fonts/notosans/NotoSans-BoldItalic-webfont.eot');
    src: url('/fonts/notosans/NotoSans-BoldItalic-webfont.eot?#iefix') format('embedded-opentype'),
         url('/fonts/notosans/NotoSans-BoldItalic-webfont.woff') format('woff'),
         url('/fonts/notosans/NotoSans-BoldItalic-webfont.ttf') format('truetype'),
         url('/fonts/notosans/NotoSans-BoldItalic-webfont.svg#noto_sansregular') format('svg');
    font-weight: 700;
    font-style: italic;

}
html {
    font-family: "NotoSans";
}
`;
exports.default = {
    fontFamily,
    mainInfoLandscape,
    mainInfoPortrait,
    headerTextColor,
    brand,
    headerBackgroundColor,
    style,
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
